import type {Root} from 'hast'
import {visit} from 'unist-util-visit'
import {SKIP} from 'unist-util-visit-parents'

import {isTag} from '../hast-utils'

/** Updates code/pre nodes to add attributes to disable spellcheck and other browser autocomplete features. */
export function disableSpellcheckInCodeElements(tree: Root) {
  visit(tree, 'element', element => {
    if (isTag(element, 'code') || isTag(element, 'pre')) {
      element.properties = {
        ...element.properties,
        spellcheck: 'false',
        autocorrect: 'off',
        autocapitalize: 'off',
        writingsuggestions: 'false',
      }

      // these attributes apply deeply, so no need to traverse further
      return SKIP
    }
  })
}
